module.exports = __webpack_public_path__ + "static/media/arrow_left.6b9b7b1e.svg";